import { render, staticRenderFns } from "./noticeCn.vue?vue&type=template&id=0077d3fc&scoped=true&"
import script from "./noticeCn.vue?vue&type=script&lang=js&"
export * from "./noticeCn.vue?vue&type=script&lang=js&"
import style0 from "./noticeCn.vue?vue&type=style&index=0&id=0077d3fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0077d3fc",
  null
  
)

export default component.exports